import * as types from './types';

export const setLoading = isLoading => ({
  type: types.CANDIDATE_DOCUMENT_TYPES_SET_LOADING,
  isLoading
});

export const setCandidateDocumentTypes = documentTypes => ({
  type: types.CANDIDATE_DOCUMENT_TYPES_SET_TYPES,
  documentTypes
});

export const resetCandidateDocumentTypes = () => ({
  type: types.CANDIDATE_DOCUMENT_TYPES_RESET_TYPES
});

export const getCandidateDocumentTypes = () => ({
  type: types.CANDIDATE_DOCUMENT_TYPES_GET_TYPES
});



// WEBPACK FOOTER //
// ./src/actions/candidate/candidate-document-types/index.js